export default function checkIfIsBecomeDomain() {
  const { hostname } = window.location;

  return hostname?.includes('joinbecome.com') ?? false;
}
